import { StackScreenProps } from "@react-navigation/stack";
import { ShiftRootParamList } from "../../../../types";
import { useCallback } from "react";
import { QUERY_TERMINAL_SHIFT_LIST } from "../../../../utilities/terminal-shift/constants";
import { TerminalClosure } from "@towersystems/roam-common/lib/generated-types";
import { useEndOfShiftContextProvider } from "../../utils/shift/hooks";
import { useFocusEffect } from "@react-navigation/native";
import { Page } from "@towersystems/roam-common-native";
import { ShiftList } from "../../components/ShiftList";
import { useLoadMoreList } from "../../../../utilities/load-more-list";
import { FlatListSearchableSkeleton } from "../../../../components/FlatListSearchableSkeleton";
import { EmptyList } from "../../../../components/EmptyList";

export interface ShiftHistoryScreenProps
  extends StackScreenProps<ShiftRootParamList, "ShiftHistoryScreen"> {}

export const ShiftHistoryScreen = ({ navigation }: ShiftHistoryScreenProps) => {
  const { shiftTerminal } = useEndOfShiftContextProvider();

  const loadMoreList = useLoadMoreList<TerminalClosure>({
    initialLoad: true,
    query: QUERY_TERMINAL_SHIFT_LIST,
    resultKey: "terminalClosures",
    sort: { updatedAt: "DESC" },
    variableFormatter: (variables) => {
      const { filter, ...rest } = variables;
      return {
        options: {
          ...variables,
          filter: {
            ...filter,
            terminalId: { eq: shiftTerminal.id },
            terminalCloseDate: { after: "2000-01-01T03:28:11.103Z" },
          },
        },
      };
    },
  });

  const handleLoadMore = useCallback(
    (reset?: boolean) => {
      loadMoreList.loadMore(undefined, reset);
    },
    [loadMoreList.loadMore]
  );

  useFocusEffect(
    useCallback(() => {
      handleLoadMore(true);
    }, [shiftTerminal.id])
  );

  const items: TerminalClosure[] = loadMoreList.items || [];

  if (loadMoreList.loading && items.length <= 0) {
    return (
      <Page>
        <FlatListSearchableSkeleton />
      </Page>
    );
  }

  if (!loadMoreList.loading && items.length <= 0) {
    return (
      <Page title="Recent Shifts" scrollable={false} padding={0} fullWidth>
        <EmptyList />
      </Page>
    );
  }

  return (
    <Page title="Recent Shifts">
      <ShiftList items={items} onEndReached={() => handleLoadMore(false)} />
    </Page>
  );
};
